import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Home from "@/pages/Home";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { api } from "@/lib/api";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import CustomCursor from "@/components/CustomCursor";
import Loader from "@/components/Loader";

// Mount cursor only on storefront routes, not admin routes
function ConditionalCursor() {
    const { pathname } = useLocation();
    if (pathname.startsWith("/admin")) return null;
    return <CustomCursor />;
}

function App() {
    const [loaderShown, setLoaderShown] = useState(false);

    useEffect(() => {
        api.post("/seed").catch(() => {});
        // Show loader once per session
        const seen = sessionStorage.getItem("em_loader_seen");
        if (!seen) {
            setLoaderShown(true);
            sessionStorage.setItem("em_loader_seen", "1");
        }
    }, []);

    return (
        <div className="App font-sans">
            {loaderShown && <Loader />}
            <CartProvider>
                <BrowserRouter>
                    <ConditionalCursor />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/checkout/success" element={<CheckoutSuccess />} />
                        <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    </Routes>
                    <CartDrawer />
                </BrowserRouter>
            </CartProvider>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0A0A0A",
                        border: "1px solid #27272A",
                        color: "#FAFAFA",
                        borderRadius: 0,
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
